export default __webpack_public_path__ + "static/media/DeleteButtonNew.38d7d104.svg";